
const messages = {
  en: {
    movimiento: {
      title: 'Movimiento management',
      menuTitle: 'Movements',
      subtitle: 'View, search, create, edit and delete Movimiento',
      creating: 'Creating Movimiento',
      editing: 'Editing Movimiento',
      deleting: 'Deleting Movimiento',
      showing: 'Showing Movimiento',
      labels: {
        productos: 'productos',
        cantidad: 'quantity',
        fecha: 'date',
        idProducto: 'producto id',
        precioTotal: 'total price',
        descuento: 'discount',
        precio: 'price',
        precioUnitario: 'Unit price',
        subtotalLinea: 'Subtotal (no offer)',
        oferta: 'Offer',
        medioDePago: 'payment method',
        recargo: 'charge',
        tipo: 'Type'
      },
    },
    devolucion: {
      title: 'Product return',
      subtitle: 'Return products and add new ones',
      creating: 'Creating return',
      labels: {
        productosDevueltos: 'Returned products',
        productosNuevos: 'New products',
        montoDevolucion: 'Amount to refund',
        montoAdicional: 'Additional amount to pay',
        reembolso: 'Refund to customer',
        tipo: 'Type',
        agregarProductoDevuelto: 'Add returned product',
        agregarProductoNuevo: 'Add new product',
        buscarProducto: 'Search product',
        seccionDevueltos: 'Returned Products',
        seccionNuevos: 'New Products',
        seccionPago: 'Payment Summary',
        clientePaga: 'Customer pays',
        clienteRecibe: 'Customer receives refund',
        intercambioSinDinero: 'Exchange without money'
      }
    }
  },
  es: {
    movimiento: {
      title: 'Administración de Movimiento',
      menuTitle: 'Movimientos',
      subtitle: 'Ver, buscar, crear, editar, y borrar Movimiento',
      creating: 'Creando Movimiento',
      editing: 'Modificando Movimiento',
      deleting: 'Eliminando Movimiento',
      showing: 'Detalles de Movimiento',
      labels: {
        productos: 'productos',
        cantidad: 'cantidad',
        fecha: 'fecha realización',
        idProducto: 'codigo del producto',
        precioTotal: 'precio total',
        descuento: 'descuento',
        precio: 'precio',
        precioUnitario: 'precio unitario',
        subtotalLinea: 'Subtotal línea',
        oferta: 'oferta',
        medioDePago: 'medio de pago',
        recargo: 'recargo',
        tipo: 'Tipo'
      },
    },
    devolucion: {
      title: 'Devolución de productos',
      subtitle: 'Devolver productos y agregar nuevos',
      creating: 'Creando devolución',
      labels: {
        productosDevueltos: 'Productos a devolver',
        productosNuevos: 'Productos a vender',
        montoDevolucion: 'Monto a devolver',
        montoAdicional: 'Monto adicional a pagar',
        reembolso: 'Reembolso al cliente',
        tipo: 'Tipo',
        agregarProductoDevuelto: 'Agregar producto devuelto',
        agregarProductoNuevo: 'Agregar producto nuevo',
        buscarProducto: 'Buscar producto',
        seccionDevueltos: 'Productos a devolver',
        seccionNuevos: 'Productos a vender',
        seccionPago: 'Resumen de Pago',
        clientePaga: 'Cliente paga',
        clienteRecibe: 'Cliente recibe reembolso',
        intercambioSinDinero: 'Intercambio sin dinero'
      }
    }
  },
  pt: {
    movimiento: {
      title: 'Administração de Movimiento',
      menuTitle: 'Movimentos',
      subtitle: 'Ver, buscar, criar, editar e usar Movimiento',
      creating: 'Criando Movimiento',
      editing: 'Edição Movimiento',
      deleting: 'Apagando Movimiento',
      showing: 'Detalhes do Movimiento',
      labels: {
        productos: 'produtos',
        cantidad: 'quantia',
        fecha: 'encontro',
        idProducto: 'producto id',
        precioTotal: 'precio total',
        descuento: 'descuento',
        precio: 'precio',
        precioUnitario: 'preço unitário',
        subtotalLinea: 'Subtotal linha',
        oferta: 'oferta',
        medioDePago: 'medio de pago',
        recargo: 'sobretaxa',
        tipo: 'Tipo'
      },
    },
    devolucion: {
      title: 'Devolução de produtos',
      subtitle: 'Devolver produtos e adicionar novos',
      creating: 'Criando devolução',
      labels: {
        productosDevueltos: 'Produtos devolvidos',
        productosNuevos: 'Produtos novos',
        montoDevolucion: 'Valor a devolver',
        montoAdicional: 'Valor adicional a pagar',
        reembolso: 'Reembolso ao cliente',
        tipo: 'Tipo',
        agregarProductoDevuelto: 'Adicionar produto devolvido',
        agregarProductoNuevo: 'Adicionar produto novo',
        buscarProducto: 'Buscar produto',
        seccionDevueltos: 'Produtos Devolvidos',
        seccionNuevos: 'Produtos Novos',
        seccionPago: 'Resumo de Pagamento',
        clientePaga: 'Cliente paga',
        clienteRecibe: 'Cliente recebe reembolso',
        intercambioSinDinero: 'Troca sem dinheiro'
      }
    }
  }
}

export default messages
